import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-391" data-mp="wv62lp6jfojq">
      {/* Navigation placeholder - minimal for landing page */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-392" data-mp="mwqd1qn5sncc">
        <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-393" data-mp="3cm22s6g7xdao" />
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-394" data-mp="3f0ja195n8hj8">
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-395" data-mp="3j1cxy2j35wc4">
            Practitioners
          </a>
          <a href="/investors" className="hover:text-purple-700 transition-colors" data-id="element-396" data-mp="3a0eqtbdcp8pb">
            Investors
          </a>
        </div>
      </nav>

      <Hero data-id="element-397" data-mp="2v9e7ucez9wex" />
      <ProblemSection data-id="element-398" data-mp="2v9ny813xq5l5" />
      <CaseStudy data-id="element-399" data-mp="302quwi40dv5k" />
      <SolutionSection data-id="element-400" data-mp="30390448nfjpm" />
      <ProductExperience data-id="element-401" data-mp="303s5yml0yhna" />
      <CompetitiveEdge data-id="element-402" data-mp="30420mnh0lczb" />
      <LeadershipSection data-id="element-403" data-mp="2mbccace0jvz1" />
      <FinalCTA data-id="element-404" data-mp="2mbvm15tife1z" />

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 border-t border-white/10" data-id="element-405" data-mp="2m8znbf9u8lch">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm" data-id="element-406" data-mp="2r7szn4de26b2">
          <p data-id="element-407" data-mp="2hbg7iaxhs0if">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
          <a href="/privacy-policy" className="hover:text-ivory transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 rounded" data-id="element-408" data-mp="2hdk8ol40alf0">
            Privacy Policy
          </a>
        </div>
      </footer>
    </main>;
}